// extracted by mini-css-extract-plugin
export default {"locationInput":"SearchBarKeyWordInput_locationInput__5iffu","locationInputContainer":"SearchBarKeyWordInput_locationInputContainer__3NlAT"};